import {
  CLEAR_LICENCIAS_ACTION,
  FETCH_LICENCIAS,
  DELETE_LICENCIA,
} from './actions.type';

import {
  SET_ERROR,
  CLEAR_ALERT_DIALOG,
  CLEAR_LICENCIAS,
  FETCHED_LICENCIAS,
  FETCHING_LICENCIAS,
  CLEAR_LICENCIAS_INFO,
  SET_LICENCIA,
  FETCHING_LICENCIA,
  FETCHED_LICENCIA,
  SUBMITED_LICENCIA,
  SUBMIT_LICENCIA_ERROR,
  SUBMITED_LICENCIA_DELETE,
  RESET_LICENCIA_SUBMIT,
  RESET_LICENCIA_PROCESSING,
  STARTED_LICENCIA_PROCESSING,
  GENERATE_CREDENTIAL,
} from './mutations.type';
// eslint-disable-next-line import/no-cycle
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  loading_licencias: false,
  loading_licencia: false,
  processing_licencia: false,
  submited_licencia: false,
};

const getters = {
  is_loading() {
    return state.loading_licencias;
  },
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
  alertDialog(state) {
    return state.alertDialog;
  },
  alertDialogMessage(state) {
    return state.alertDialogMessage;
  },
  alertDialogType(state) {
    return state.alertDialogType;
  },
  licencia_processing() {
    return state.processing_licencia;
  },
  licencia_submited() {
    return state.submited_licencia;
  },
};

const actions = {
  [GENERATE_CREDENTIAL](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_LICENCIA);
      context.commit(CLEAR_LICENCIAS_INFO);
      ApiService.post('usuarios/generate_licence_credential', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [DELETE_LICENCIA](context, id) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post(`vehiculos/licencia/delete/${id}`)
        .then(({ data }) => {
          context.commit(SUBMITED_LICENCIA_DELETE);
          resolve(data);
          // context.dispatch(FETCH_MASCOTAS);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_LICENCIA_ERROR, [response.data.message]);
        });
    });
  },
  [FETCH_LICENCIAS](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_LICENCIAS);
      ApiService.query('vehiculos/licencias', { params: data })
        .then(({ data }) => {
          context.commit(FETCHED_LICENCIAS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_LICENCIAS);
        });
    });
  },
  [CLEAR_LICENCIAS_ACTION](context) {
    context.commit(CLEAR_LICENCIAS);
  },
};

const mutations = {
  [SUBMITED_LICENCIA_DELETE](state) {
    state.alert = true;
    state.alertMessage = 'Licencia Eliminada Correctamente';
    state.alertType = 'success';
    state.submited_licencia = true;
  },
  [FETCHING_LICENCIAS](state) {
    state.loading_licencias = true;
  },
  [FETCHED_LICENCIAS](state) {
    state.loading_licencias = false;
  },
  [CLEAR_LICENCIAS_INFO](state) {
    state.licencias_info = {};
  },
  [SET_LICENCIA](state, data) {
    state.licencia_info = data.licencia;
  },
  [FETCHING_LICENCIA](state) {
    state.loading_licencia = true;
  },
  [FETCHED_LICENCIA](state) {
    state.loading_licencia = false;
  },
  [SUBMITED_LICENCIA](state, data) {
    state.submited_licencia = true;
    state.alert = true;
    if (data.code !== 0) {
      state.alertType = 'error';
      state.alertMessage = data.message;
    } else {
      state.alertType = 'success';
      state.alertMessage = data.message;
    }
  },
  [SUBMIT_LICENCIA_ERROR](state, data) {
    state.processing_licencia = false;
    state.alertDialog = true;
    state.alertDialogType = 'error';
    state.alertDialogMessage = data;
  },
  [RESET_LICENCIA_SUBMIT](state) {
    state.submited_licencia = false;
    state.alert = false;
    state.alertMessage = 'default';
    state.alertType = 'warning';
  },
  [CLEAR_ALERT_DIALOG](state) {
    state.alert = false;
    state.alertMessage = '';
    state.alertType = 'success';
  },
  [RESET_LICENCIA_PROCESSING](state) {
    state.processing_licencia = false;
  },
  [STARTED_LICENCIA_PROCESSING](state) {
    state.processing_licencia = true;
  },
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
